import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { translateAnimalCategory, translateAnimalCategoryAge } from "../../../../i18n/translateAnimalCategory";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";

interface InfoAnimalSellProps {
  task: ITaskAnimalResolver | undefined;
}


export default function InfoAnimalSell(task: InfoAnimalSellProps) {
  const { t } = useTranslation();
  const [taskSell, setTaskSell] = useState<ITaskAnimalResolver>();
  useEffect(() => {
    setTaskSell(task.task)
  }, []);

  return (
    <>
      <div >
        <span><Trans i18nKey="taskDetails.onArea" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AreaIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskSell?.area_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div >
        <span><Trans i18nKey="taskDetails.onBatch" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AnimalsIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskSell?.batch_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={t("taskMonitoring.details.liveOrSlaughter")} pointed />
        <ButtonPressed
          onlyResult
          optionSelected={1}
          value={1}
          text={t(taskSell?.task_update_type === "Venda" ? "taskMonitoring.details.live" : "taskMonitoring.details.slaughter")}
        />
      </div>

      {taskSell?.details.map((detail, index) => (
        <>
          {detail.categories.map((category, index) => (
            <div key={index}>
              <div className="lot__title--category" style={{ marginTop: 0 }}>{translateAnimalCategory(category.category_description.name, category.category_description.age_description)}</div>
              <div className="lot__subtitle--category">{translateAnimalCategoryAge(category.category_description.age_description, category.category_description.name)}</div>
              <CounterInputV2 name={`info-animal-sell-qty-${index}`} value={Number(category.quantity ?? 0)} disabled />
            </div>
          ))}
        </>
      ))}
    </>
  )
}
